import { FC } from 'react';
import { SERVICE_PROVIDERS, EspAccount } from 'modules/graphql/types';
import { MobileApp, IntegrationPlatform } from 'modules/mobileApps/types';
import { SvgLogoProps } from 'ui/thirdPartyLogos/SvgLogo';
import { VariantLogoProps } from 'ui/logo';
import { EmailChannel } from './emailChannels';
import { MessageType } from './messageTypes';
import { SmsSender } from './smsSenders';
import { VerificationProfile } from './verificationProfiles';

export * from './emailChannels';
export * from './messageTypes';
export * from './smsSenders';
export * from './verificationProfiles';

export interface SendingPlatformMetadata {
  name: string;
  id: string;
  indexDescription: string;
  editDescription: string;
  supportLink?: string;
  partnerLink?: string;
  category: SENDING_PLATFORM_CATEGORIES;
  logoSvg?:
    | FC<React.PropsWithChildren<SvgLogoProps>>
    | FC<React.PropsWithChildren<VariantLogoProps>>;
}

export enum SENDING_PLATFORM_CATEGORIES {
  EMAIL = 'Email',
  SMS = 'SMS',
  PUSH = 'Push',
  WHATS_APP = 'WhatsApp',
}

export type FetchEspAccountsResponse = {
  espAccounts: EspAccount[];
};

export type CustomMtaConfigPayload = {
  name: string;
  apiEndpoint: string;
  authType: string; // will be "OAuth2"
  authParams: {
    clientId: string;
    clientSecret: string;
    tokenEndpoint: string;
  };
  customHeaders: Record<string, string>;
};

export type FetchVerificationProfilesResponse = {
  verificationProfiles: VerificationProfile[];
};

export type FetchWhatsAppAccountsResponse = {
  appId: string;
  configId: string;
  euSolutionId: string;
  usSolutionId: string;
};

export type CreateEspAccountPayload = {
  name: string;
  esp: SERVICE_PROVIDERS;
  apiKey: string;
  binding?: string;
  apiEndpoint?: string;
  customMTAConfig?: CustomMtaConfigPayload;
  signingSecret?: string;
};

export type EditEspAccountPayload = CreateEspAccountPayload & {
  id: number;
  editApiKey: boolean;
  isDefault: boolean;
  isSenderIterable?: boolean;
  editSigningSecret?: boolean;
};

export type DeleteEspAccountPayload = {
  id: number;
};

export enum ESP_ACCOUNT_PAYLOAD_FIELDS {
  ID = 'id',
  ESP = 'esp',
  NAME = 'name',
  API_KEY = 'apiKey',
  BINDING = 'binding',
  API_ENDPOINT = 'apiEndpoint',
  SIGNING_SECRET = 'signingSecret',
  EDIT_API_KEY = 'editApiKey',
  EDIT_SIGNING_SECRET = 'editSigningSecret',
  IS_SENDER_ITERABLE = 'isSenderIterable',
  IS_DEFAULT = 'isDefault',
  CLIENT_ID = 'clientId',
  CLIENT_SECRET = 'clientSecret',
  EDIT_CLIENT_SECRET = 'editClientSecret',
  TOKEN_ENDPOINT = 'tokenEndpoint',
  AUTH_TYPE = 'authType',
  CUSTOM_HEADERS = 'customHeaders',
}
export enum AuthType {
  OAUTH2 = 'OAuth2',
}

export type AccountFormFields = {
  name: string;
  apiKey: string;
  binding: string;
  apiEndpoint: string;
  esp: SERVICE_PROVIDERS;
  signingSecret?: string;
};

export type MergedEmailChannel = EmailChannel & {
  messageTypes: MessageType[];
};

export type MergedSmsSender = SmsSender & {
  messageType: MessageType;
};

export type CustomMTAMobileApp = MobileApp & {
  // TODO: Confirm the correctness of this type once Backend API is provided
  pushCustomMTAConfig: {
    id: number;
    androidUseOsNotifications?: boolean;
    testPushSuccess?: boolean;
    pushPlatform: IntegrationPlatform;
    customMTAConfigId: number;
  };
};
